import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';
import { Question } from 'api/requests/communityBuzz/interfaces';
import { calculateTimeSince } from './utils';
import { BUMPER_AI_USERNAME, isBumperAIContributor } from './constants';
import { useContext } from 'react';
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { COMMUNITY_BUZZ_GA4_EVENTS } from 'components/CommunityBuzz/constants';

interface QuestionDetailsProps {
  question?: Question;
  onOpenQADisplayModal?: () => void;
  setSelectedQuestion?: (question?: Question) => void;
}
export const QuestionDetails = ({
  question,
  onOpenQADisplayModal,
  setSelectedQuestion,
}: QuestionDetailsProps) => {
  const { trackEventGA4 } = useContext(AppConfig);
  const handleOpenQADisplayModal = () => {
    onOpenQADisplayModal?.();
    setSelectedQuestion?.(question);
    const { communityBuzzViewQuestionAction } = COMMUNITY_BUZZ_GA4_EVENTS;
    trackEventGA4({
      event_name: communityBuzzViewQuestionAction.name,
      type: communityBuzzViewQuestionAction.type,
    });
  };

  return (
    <Stack width="100%">
      <Stack
        width="100%"
        spacing={1}
        onClick={handleOpenQADisplayModal}
        sx={{ cursor: 'pointer' }}
      >
        <Text variant="h5" mb={0}>
          {question?.body_md}
        </Text>
        <Stack direction="row" spacing={1}>
          <Text variant="body2" color="text.secondary">
            {calculateTimeSince(question?.created_at)}
          </Text>
          <Text variant="body2" color="text.secondary">
            •{' '}
            {isBumperAIContributor(question?.source, question?.username)
              ? BUMPER_AI_USERNAME
              : question?.username}
          </Text>
        </Stack>
      </Stack>
      <Divider sx={{ mt: 2 }} />
    </Stack>
  );
};
